/// CQ 20180531
/// 授权HTTP请求工具

import * as basicHttp from './basicHttp.js'
const base64 = require('../alioss/Base64.js')
const config = require('../config.js')

function getRefreshToken(){
  var refresh_token = uni.getStorageSync('refresh_token')
  if (!refresh_token) {
    return ''
  }
  else {
    return refresh_token
  }
}

function authorization(t) {
  return t.startsWith('Bearer ') ? t : 'Bearer ' + t
}
export const getToken = function () {
  var tempToken = uni.getStorageSync('temp_token')
  if (!tempToken) {
    return ''
  } else {
    return tempToken
  }
}

export const get = function (url, data,access_token,clientId) {
  let header = {}
  if(access_token) {
    header =Object.assign(header, { "Authorization": authorization(access_token)})
  }
  header =Object.assign(header, { "tenantId": clientId})
  if(url && (url.indexOf('user/login/c') >= 0 || url.indexOf('oauth/token') >= 0)){
    // client:secret
    let clientSecretStr = clientId + ':' + config.clientSecret
    let clientSecretCode = base64.encode(clientSecretStr)
    header = Object.assign(header, { "Authorization": 'Basic ' + clientSecretCode})
  }
  return basicHttp.get(url, data, header)
}

export const post = function (url, data,access_token,clientId) {
  let header = {}
  if(access_token) {
    header =Object.assign(header, { "Authorization": authorization(access_token)})
  }
  header =Object.assign(header, { "tenantId": clientId})
  if(url && (url.indexOf('user/login/c') >= 0 || url.indexOf('oauth/token') >= 0)){
    // client:secret
    let clientSecretStr = clientId + ':' + config.clientSecret
    let clientSecretCode = base64.encode(clientSecretStr)
    header = Object.assign(header, { "Authorization": 'Basic ' + clientSecretCode})
  }
  return basicHttp.post(url, data, header)
}

export default {
  getRefreshToken,
  getToken,
  get,
  post
}
